import { jsx as o } from "react/jsx-runtime";
import t from "../svg-icon/svg-icon.component.js";
function e(r) {
  return /* @__PURE__ */ o(t, { width: "24", height: "24", viewBox: "0 0 24 24", ...r, children: /* @__PURE__ */ o("path", { d: "M9.06 18.81C8.87 18.81 8.68 18.74 8.53 18.59L3 13.06L4.06 12L9.06 17L20.06 6L21.12 7.06L9.59 18.59C9.44 18.74 9.25 18.81 9.06 18.81Z" }) });
}
export {
  e as DoneIcon
};
//# sourceMappingURL=done.js.map
